import { render, staticRenderFns } from "./r-smart-offer-bundle-novice-battle-pass.vue?vue&type=template&id=51034b13"
import script from "./r-smart-offer-bundle-novice-battle-pass.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-novice-battle-pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51034b13')) {
      api.createRecord('51034b13', component.options)
    } else {
      api.reload('51034b13', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-novice-battle-pass.vue?vue&type=template&id=51034b13", function () {
      api.rerender('51034b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-novice-battle-pass/r-smart-offer-bundle-novice-battle-pass.vue"
export default component.exports